import { useRouter } from 'next/router';
import { AD_UNIT_PAGES } from '../types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPageSuffixForAdUnit = (mapping: any): AD_UNIT_PAGES => {
    const router = useRouter();
    const { route } = router;

    const page = Object.entries(mapping).find((k) => route.startsWith(k[0]));

    if (page === undefined) {
        return AD_UNIT_PAGES.UNKNOWN;
    }

    return <AD_UNIT_PAGES>page[1];
};
